import { render, staticRenderFns } from "./AffixDoc.vue?vue&type=template&id=85abeff0&scoped=true"
import script from "./AffixDoc.vue?vue&type=script&lang=js"
export * from "./AffixDoc.vue?vue&type=script&lang=js"
import style0 from "./AffixDoc.vue?vue&type=style&index=0&id=85abeff0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85abeff0",
  null
  
)

export default component.exports